import SamsungApp from './Samsung';

export default SamsungApp;
